import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  ChevronRight,
  ExternalLink,
  ExternalLinkOff
} from 'tabler-icons-react';
import { Context as VendorContext } from '../../../providers/VendorContextProvider';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import AppFlexbox from '../../common/AppFlexbox';
import { useModalState } from '../../../helpers/hooks';
import SettingCard from '../../common/SettingCard';
import SettingSelector from '../../common/SettingSelector';
import { EXTERNAL_CONNECTION_CONFIGS } from './config/externalConnectionConfigs';
import ExternalConnectionSetupModal from './ExternalConnectionSetupModal';

const ExternalConnectionSettings = ({ disabled }) => {
  const { state } = useContext(VendorContext);
  const { state: modalState, onOpenModal, onCloseModal } = useModalState();

  return (
    <>
      <SettingCard
        description="Manage your external connections to ensure seamless integration with third-party services. This includes connecting to payment providers, email services, and other platforms that enhance your vendor's functionality."
        title="External connections"
      >
        <AppStack style={{ gap: 10 }}>
          <AppStack style={{ gap: 5 }}>
            <AppText style={{ fontWeight: 500 }}>External Connections</AppText>
            <AppText style={{ fontSize: 14, color: '#666' }} />
          </AppStack>

          {EXTERNAL_CONNECTION_CONFIGS.sort((a, b) =>
            a.title.localeCompare(b.title)
          ).map((config) => {
            const vendorExternalConnection = state.ecomVendorSetupSummary.value?.ecomVendor.ecomVendorExternalConnections.find(
              (f) =>
                f.fkEcomExternalConnectionType.toString() ===
                config.pkEcomExternalConnectionType.toString()
            );

            const isConnected = !!vendorExternalConnection;

            return (
              <SettingSelector
                key={config.pkEcomExternalConnectionType}
                description={isConnected ? 'Connected' : 'Not connected'}
                descriptionColor={isConnected ? 'green' : '#c40000'}
                disabled={disabled}
                leftSection={
                  isConnected ? (
                    <ExternalLink color="green" size={32} />
                  ) : (
                    <ExternalLinkOff color="#c40000" size={32} />
                  )
                }
                onClick={() => {
                  onOpenModal('setup', config);
                }}
                rightSection={
                  <AppFlexbox style={{ gap: 5, alignItems: 'center' }}>
                    <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                      {isConnected ? 'Click to update' : 'Click to connect'}
                    </AppText>
                    <ChevronRight size={18} />
                  </AppFlexbox>
                }
                title={config.title}
                withBorder
              />
            );
          })}
        </AppStack>
      </SettingCard>

      <ExternalConnectionSetupModal
        config={modalState.item}
        isOpen={modalState.isOpen}
        onClose={onCloseModal}
      />
    </>
  );
};

ExternalConnectionSettings.propTypes = { disabled: PropTypes.bool };

export default ExternalConnectionSettings;
